import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { laborRateApi } from '../../services/api';
import type { LaborRate } from '../../types';

export function LaborRatePicker({
  valueId,
  onPick,
  disabled,
  size = 'small',
  style,
}: {
  valueId?: number | null;
  onPick: (rate: { id: number; hourly_rate: number }) => void;
  disabled?: boolean;
  size?: 'small' | 'middle' | 'large';
  style?: React.CSSProperties;
}) {
  const [rates, setRates] = useState<LaborRate[]>([]);
  useEffect(() => {
    laborRateApi.getAll().then(r => setRates(r.data)).catch(() => setRates([]));
  }, []);
  return (
    <Select
      size={size}
      style={{ minWidth: 130, ...style }}
      disabled={disabled}
      value={valueId ?? undefined}
      placeholder="Labor rate"
      onChange={(id: number) => {
        const r = rates.find(x => x.id === id);
        if (r) onPick({ id: r.id, hourly_rate: r.hourly_rate });
      }}
      options={rates.map(r => ({ value: r.id, label: `${r.name} ($${r.hourly_rate}/hr)` }))}
    />
  );
}
